import { render } from "./ModalQnaAdd.vue?vue&type=template&id=3e99ecf9&scoped=true"
import script from "./ModalQnaAdd.vue?vue&type=script&lang=js"
export * from "./ModalQnaAdd.vue?vue&type=script&lang=js"

import "./ModalQnaAdd.vue?vue&type=style&index=0&id=3e99ecf9&scoped=true&lang=css"

import exportComponent from "/home/hosting_users/shoplus/custom/survey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e99ecf9"]])

export default __exports__